import { useParams } from "react-router";

import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TextEllipsis from "ds/components/TextEllipsis";
import { formatDate } from "utils/date";
import { getHumanizedTimestamp, unixTimestampToMs } from "utils/time";

import { ScanRunsListItem } from "../../../types";

const ScanRunsTableScheduledCell = ({
  item: run,
  ...cellProps
}: TableSimpleCellProps<ScanRunsListItem>) => {
  const { scanId = "" } = useParams<{ scanId: string }>();
  const scheduledAtMs = unixTimestampToMs(run.createdAt);

  return (
    <TableSimpleCell {...cellProps}>
      <TextEllipsis tooltip={formatDate({ date: scheduledAtMs })} forceTooltipActive>
        {(props) => (
          <TableCellLink
            {...props}
            href={`/resources/scans/${scanId}/scan-runs/${run.id}/resources`}
          >
            {getHumanizedTimestamp(scheduledAtMs)}
          </TableCellLink>
        )}
      </TextEllipsis>
    </TableSimpleCell>
  );
};

export default ScanRunsTableScheduledCell;
